import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { IngresoEgresoService } from '../../../../services/ingresosegreso.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { take } from 'rxjs/operators';
import { IngresoEgreso } from 'src/app/models/ingresoegreso.model';
import { ResultList } from '../../../../interfaces/generic.interface';
import { ImpresionService } from 'src/app/services/impresion.service';
import { CustomGridSettings, FieldType } from 'src/app/shared/custom-grid/grid.models';
import { GridBuilderService } from 'src/app/shared/custom-grid/grid.builder';
import { CustomGridService } from 'src/app/shared/custom-grid/grid.service';

@Component({
  selector: 'app-ingresoegreso-list',
  templateUrl: './ingresoegreso-list.component.html',
  styleUrls: ['./ingresoegreso-list.component.css']
})
export class IngresoEgresoListComponent implements OnInit, AfterViewInit {
  displayedColumns = ['numero', 'fecha', 'formaPago', 'cuit', 'monto','grado','alumno', 'id', 'accion'];
  dataSource = new MatTableDataSource<IngresoEgreso>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  gridBuilder = new GridBuilderService();
  gridSettings: CustomGridSettings;

  constructor(private service: IngresoEgresoService, private impresion: ImpresionService,private customGridService: CustomGridService,) { }

  ngOnInit() {
    this.service.getIngresoEgresosPorEscuela(0, 100)
      .pipe(take(1))
      .subscribe((fs: ResultList<IngresoEgreso>) => {
        this.dataSource.data = fs.resultList;
      });

      this.gridSettings = this.gridBuilder.withData([])
          .withTotalRows(this.dataSource.data.length)
          .build();
        this.setGridSettings(this.gridSettings);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  private setGridSettings(gridSettings: CustomGridSettings): void {
    this.customGridService.setGridSettings(gridSettings);
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  imprimir(ie: IngresoEgreso) {
    this.impresion.generateIngresoEgresoPDF(ie).then(result => {
    });
  }

  getExcel(){
    this.service.getExcelIngresosEgresos();
  }
  // getData(pageIndex, pageSize, filter) {
	// 	const dataFilter = {filterLike: filter, gradoId: this.gradoId, inactivos: this.inactivos};
	// 	this.subscriptions.push(this.alumnoService.getAlumnosPorEscuelaYFiltros(pageIndex, pageSize, dataFilter).subscribe((fs: AlumnoList) => {
	// 		this.dataSource = new MatTableDataSource<any>(fs.resultList);
	// 		this.length = fs.total;
	// 		this.paginator.length = this.length;
	// 		this.dataSource._updateChangeSubscription();
	// 	}));
	// }

  // public getServerData(event?: PageEvent) {
	// 	if(this.stringFilter && this.stringFilter.length > 2){
	// 		this.pageIndex = event.pageIndex;
	// 		this.applyFilter();
	// 		return event;
	// 	}else{
	// 		this.getData((event.pageIndex + 1), event.pageSize, '');
	// 		return event;
	// 	}
	// }

  getGridSettings(): CustomGridSettings {
    this.gridBuilder.reset();
    return this.gridBuilder
      .AddColumn('customerId', (options) => {
        options.sortProperty = 'CustomerId';
        options.headerName = 'Account #';
        options.headerStyleClass = 'grid-col-small';
        options.styleClass = 'grid-col-small';
      })
      .AddColumn('customerName', (options) => {
        options.sortProperty = 'CustomerName';
        options.headerName = 'Account Name';
        options.headerStyleClass = 'grid-col-medium';
        options.styleClass = 'grid-col-medium';
      })
      .AddColumn('workOrder', (options) => {
        options.sortProperty = 'WorkOrder';
        options.headerName = 'WO';
        options.headerStyleClass = 'grid-col-small';
        options.styleClass = 'grid-col-small';
        options.fieldType = FieldType.Number;
      })
      .AddColumn('action', (options) => {
        options.sortProperty = 'Action';
        options.headerName = 'Action';
        options.headerStyleClass = 'grid-col-medium';
        options.styleClass = 'grid-col-medium';
      })
      .AddColumn('timeStamp', (options) => {
        options.sortProperty = 'Timestamp';

        options.headerName = 'Timestamp';
        options.headerStyleClass = 'grid-col-medium';
        options.styleClass = 'grid-col-medium';
        options.sortProperty = 'TimeStamp';
        options.dateFormat = 'yyyy/MM/dd';
        options.fieldType = FieldType.Date;
      })
      .AddColumn('previousStatus', (options) => {
        options.sortProperty = 'PreviousStatus';
        options.headerName = 'Previous Status';
        options.fieldType = FieldType.Custom;
        //options.customFieldTypeDef = StatusPipe;
        options.headerStyleClass = 'grid-col-medium';
      })
      .AddColumn('actualStatus', (options) => {
        options.sortProperty = 'ActualStatus';
        options.headerName = 'New Status';
        options.fieldType = FieldType.Custom;
        //options.customFieldTypeDef = StatusPipe;
        options.headerStyleClass = 'grid-col-medium';
      })
      .AddColumn('userName', (options) => {
        options.sortProperty = 'UserName';
        options.headerName = 'User';
        options.headerStyleClass = 'grid-col-medium';
        options.styleClass = 'grid-col-medium';
      })
      .withState((options) => {
        options.pageSize = 25;
        options.asc = true;
        options.orderBy = 'TimeStamp';
      })
      .build();
  }
}




